import { ScriptSureDrugDoseResponse } from "models/scriptSure/scriptsureDrugDoseResponse";

export const mockMedDoses: ScriptSureDrugDoseResponse[] = [
  {
    MED_MEDID_DESC: "Adult Aspirin Regimen 81 mg tablet,delayed release",
    ROUTED_MED_ID: 174440,
    GCN_SEQNO: 16995,
    MED_REF_DEA_CD: "0",
    MED_ROUTED_MED_ID_DESC: "Adult Aspirin Regimen oral",
    MED_STATUS_CD: "0",
    MED_STRENGTH: "81",
    MED_STRENGTH_UOM: "mg",
    MED_DOSAGE_FORM_DESC: "tablet,delayed release (DR/EC)",
    med_status_cd: "0",
    epn: "Adult Aspirin Regimen 81 mg tablet,delayed release",
    rxNorm: "308416",
    rxNormQualifier: "SCD",
    MED_REF_GEN_DRUG_NAME_CD: "2",
    MED_REF_FED_LEGEND_IND: "2",
    MED_NAME_TYPE_CD: "1",
    imk_preferred_ind: "0",
    ndc: "70000017801",
  },
];



// WEBPACK FOOTER //
// ./src/providers/order-data-service/mock-med-doses.ts